// import '@babel/polyfill';
// UNINSTALL: import Vuelidate from 'vuelidate';
// UNINSTALL import VeeValidate from 'vee-validate';
// UNINSTALL import UploadButton from 'vuetify-upload-button';
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@/assets/css/global.css';

import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import MultiFiltersPlugin from './plugins/MultiFilters';
import ImageContainer from '@/plugins/Attachment/ImageContainer';
import AttachmentPopup from '@/plugins/Attachment/AttachmentPopup';
import AttachmentResources from '@/plugins/Attachment/Resources';

Vue.component('image-container', ImageContainer);
Vue.component('attachment-popup', AttachmentPopup);
Vue.component('attachment-resources', AttachmentResources);

Vue.use(MultiFiltersPlugin);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
